<div class="stopwatch">
  <div class="outer-circle">
    <!-- Tick marks -->
    <div class="ticks">
      @for (tick of ticks; track $index ;let i = $index) {
      <span class="tick" [class.major]="i % 5 === 0" [ngStyle]="{ transform: 'rotate(' + (i * 6) + 'deg)' }"></span>
      }
    </div>

    <div class="inner-circle">
      <div class="top-ring">
        <span>{{count}}</span>
      </div>
      <!-- Clock hand -->
      <div class="hand" [ngStyle]="{
          'animation-duration': duration + 's'
        }"></div>
    </div>
  </div>
</div>

<!-- <div class="controls">
  <input type="number" [(ngModel)]="duration" [placeholder]="'ENTER_SECONDS' | translate" />
</div> -->